import { configureStore } from "@reduxjs/toolkit";
import promise from "redux-promise";
import rootReducer from "./reducers";

export const store = configureStore({
  reducer: rootReducer,
  middleware: [promise],
});
